import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { rutaPropia, sesionActual } from '../../../common/services/auth.js';
import { diccionarioDe, type Idioma } from '../../../i18n/index.js';

/** Espera al SDK antes de retirar el fragmento del enlace que contiene la sesión. */
export function RetornoAccesoPage({ idioma }: { readonly idioma: Idioma }) {
  const navegar = useNavigate();
  const [parametros] = useSearchParams();
  const volver = rutaPropia(parametros.get('volver')) ?? '/mi-cuenta';
  const [fallo, setFallo] = useState(false);
  useEffect(() => {
    let vigente = true;
    void sesionActual().then(
      sesion => {
        if (!vigente) return;
        if (sesion === null) {
          void navegar(`/iniciar-sesion?volver=${encodeURIComponent(volver)}`, { replace: true });
        } else {
          void navegar(volver, { replace: true });
        }
      },
      () => {
        if (vigente) setFallo(true);
      },
    );
    return () => {
      vigente = false;
    };
  }, [navegar, volver]);
  return (
    <main className='grow p-6 text-center'>
      {fallo ? diccionarioDe(idioma).cuentas.errorServicioCorreo : idioma === 'es' ? 'Cargando…' : 'Loading…'}
    </main>
  );
}
